// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"f0ca10a6","418":"2eac13ff","449":"4fc5e18b"}[chunkId] + ".chunk.js";
};